The details of the webhook subscription delivery configuration to be updated.
